import CardCommon from '@op/components/CardCommon';
import React, { useMemo, useState } from 'react';
import { Col, Row } from 'tea-component';
import ReviewsRealtime from '../components/ReviewsRealtime';
import steamPositive from '@op/assets/svg/steam_positive.svg';
import { percentageFormat } from '@op/utils/value';
import { downloadAction } from '@op/components/DownloadCommon/download-page';
import useLanguage from '@op/hooks/useLanguage';
import { channelInfo } from '@op/components/ChannelLabel';
import { useGeyEmptyText } from '../hooks';
import BubbleCommon, {
  steamPerformanceRealtimeAccumulatedSteamReviewsTips,
} from '@op/components/BubbleCommon';

const { img } = channelInfo('steam');
export default function RealtimeSteamReviews({
  timeline_of_start_time,
  timeline_of_end_time,
  list,
  old_list,
  loading,
  error,
  filter,
  wholeGameInfo,
}: {
  timeline_of_start_time: string;
  timeline_of_end_time: string;
  list: any;
  old_list: any;
  loading: boolean;
  error: boolean;
  filter: any;
  wholeGameInfo?: any;
}) {
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const [filterType, setFilterType] = useState('all_reviews');

  const { oldValue, newValue } = useMemo(() => {
    const { all_reviews, recent_reviews } = list;
    const { all_reviews: old_all_reviews, recent_reviews: old_recent_reviews } =
      old_list;
    if (filterType === 'all_reviews') {
      return {
        oldValue: old_all_reviews,
        newValue: all_reviews,
      };
    }
    return {
      oldValue: old_recent_reviews,
      newValue: recent_reviews,
    };
  }, [list, old_list, filterType]);

  const { emptyText } = useGeyEmptyText({ wholeGameInfo, isRecent: filterType === 'recent_reviews', filter });

  function downloadRealtimeSteamReviews() {
    const name = filterType === 'all_reviews' ? 'All' : 'Recent';
    downloadAction({
      limit: 150000,
      downLoadParams: {
        ...filter,
        valueKey: filterType,
        need_link: true,
        channel: ['steam'],
        channels: ['steam'],
        metrics: ['recommend', 'non_recommend'],
        ret_metrics: ['recommend', 'non_recommend'],
        types: ['total', 'slice'],
      },
      downloadFunc: 'getOverviewPcConsoleTimeline',
      simpleName: `Realtime Steam ${name} Reviews`,
      sheetName: `Realtime Steam ${name} Reviews`,
    });
  }

  const emptyTextInfo = filterType === 'all_reviews' ? undefined : emptyText;
  return (
    <CardCommon
      className="realtime-filtered-reviews-wrapper"
      title={
        <div className="filter-reviews-head">
          <img
            src={img}
            style={{
              marginRight: 5,
              marginTop: -3,
              width: 18,
              height: 18,
              verticalAlign: 'middle',
            }}
          ></img>
          {formatMessage({ id: 'Realtime Accumulated Steam Reviews(1h)' })}
          <BubbleCommon
            placement="top"
            tipsMap={steamPerformanceRealtimeAccumulatedSteamReviewsTips}
          ></BubbleCommon>
        </div>
      }
      filters={formatOptionsMessage([
        { text: 'All Reviews', value: 'all_reviews' },
        { text: 'Recent Reviews', value: 'recent_reviews' },
      ])}
      handleFilterOnChange={(value) => {
        setFilterType(value);
      }}
      loading={loading}
      loadingHeight={336}
      hasDownload
      handleDownloadOnClick={downloadRealtimeSteamReviews}
    >
      <Row style={{ marginBottom: 10 }}>
        <Col>
          <ReviewsRealtime
            oldValue={oldValue}
            newValue={newValue}
            filter={filter}
            calculationMaxMin={true}
            hasEmptyTitle={!emptyTextInfo}
            filterZero
            emptyDescText={emptyTextInfo}
            hasArea
            leftTitle={formatMessage({ id: 'Mentions' })}
            valueKey="review"
            list={[
              {
                name:
                  filterType === 'all_reviews'
                    ? 'All Reviews'
                    : 'Recent Reviews',
                color: '#5086F3',
              },
              {
                name: 'The previous corresponding period',
                color: '#A6C9FF',
              },
            ]}
          ></ReviewsRealtime>
        </Col>
        <Col>
          <ReviewsRealtime
            oldValue={oldValue}
            newValue={newValue}
            filter={filter}
            calculationMaxMin={true}
            isRatio
            filterZero
            hasArea
            hasEmptyTitle={!emptyTextInfo}
            emptyDescText={emptyTextInfo}
            leftIcon={steamPositive}
            formatValue={(value: number) =>
              percentageFormat(value * 100, '-', 0)
            }
            yAxisFormatValue={(value: number) =>
              percentageFormat(value * 100, 0, 0)
            }
            leftTitle={formatMessage({ id: 'Positive%' })}
            valueKey="score"
            list={[
              {
                name: 'This time period',
                color: '#69D19C',
              },
              {
                name: 'The previous corresponding period',
                color: '#92DEB4',
              },
            ]}
          ></ReviewsRealtime>
        </Col>
      </Row>
    </CardCommon>
  );
}
